import {JobType} from './AsyncJobQueue.types'

export const isJobInHistory = (jobId: string, jobHistory: JobType[]): boolean =>
  !!jobHistory.find((job) => job.id === jobId)
